import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import TwoTextItem from '~/components/ui/TwoTextItem';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
import useProductContent from '@/composables/useProductContent/useProductContent';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'ItemTwoSidedCard',
  components: {
    TwoTextItem: TwoTextItem,
    AzButton: AzButton,
    AzImg: AzImg,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    classes: {
      type: Object,
      default: function _default() {}
    },
    title: String,
    image: Object,
    topLabel: String,
    firstSidePercentages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    secondSideRankItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var isFrontSideVisible = ref(true);
    var toggleFrontSideVisible = function toggleFrontSideVisible() {
      isFrontSideVisible.value = !isFrontSideVisible.value;
    };
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var backItemRankComponents = computed(function () {
      return mapComponentName(props.secondSideRankItems).map(function (comp, index, arr) {
        if (comp.fields && arr.length - 1 !== index) {
          comp.fields = _objectSpread(_objectSpread({}, comp.fields), {}, {
            underline: true
          });
        }
        return comp;
      });
    });
    return {
      translate: translate,
      isFrontSideVisible: isFrontSideVisible,
      toggleFrontSideVisible: toggleFrontSideVisible,
      backItemRankComponents: backItemRankComponents
    };
  }
});